import axios from 'axios'
import moment from 'moment'
import { BUSCAR_VIAGENS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarViagens (idCidadeOrigem, idCidadeDestino, dataIda, dataVolta, idEmpresa, seEncomenda, buscaNaEmpresaSelecionada, tipoBuscaVeiculo) {
  moment(dataIda).format('YYYY-MM-DD');
  let url = `${URL}/passagem/origem/${idCidadeOrigem}/destino/${idCidadeDestino}/dataIda/${moment(dataIda).format('YYYY-MM-DD')}/empresa/${idEmpresa}?buscaTipoVeiculo=${tipoBuscaVeiculo}`;
  if (dataVolta) {
    url += `&dataRetorno=${moment(dataVolta).format('YYYY-MM-DD')}`;
  }
  if(seEncomenda){
    url += '&encomenda=true';
  }
  if(buscaNaEmpresaSelecionada !== null && buscaNaEmpresaSelecionada !== undefined ){
    if(dataVolta || seEncomenda){
      url += '&buscaNaEmpresaSelecionada='+buscaNaEmpresaSelecionada;
    }else {
      url += '&buscaNaEmpresaSelecionada='+buscaNaEmpresaSelecionada;
    }

  }
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_VIAGENS,
        payload: response

      })
  );
}
